import { rewardsBalanceUrl } from "./endpoints.js";
const rewardsBalanceCacheKey = ({
  accountId,
  accountIdType,
  lang
}) => [rewardsBalanceUrl, { accountId, accountIdType, lang }];
export {
  rewardsBalanceCacheKey
};
//# sourceMappingURL=cacheKeys.js.map
